import { useEffect, useState } from "react";
import { Link, useNavigate, useParams } from "react-router-dom";
import Swal from "sweetalert2";
import axios from "axios";
import Adminnavbar from "../Adminnavbar";

export default function EditBlog() {
  const { id } = useParams();
  const navigate = useNavigate();

  const [loader, setLoader] = useState(false);
  const [photoPreviewUrl, setPhotoPreviewUrl] = useState(null);

  const [blog, setBlog] = useState({
    title: "",
    description: "",
    photo: null,
  });

  // ================= GET BLOG DATA =================

  useEffect(() => {
    const getBlogData = async () => {
      try {
        const res = await axios.get(
          `${process.env.REACT_APP_BACKEND_BASE_URL}/blog/${id}`
        );

        if (res.status === 200) {
          setBlog({
            title: res.data.data.title,
            description: res.data.data.description,
            photo: null,
          });

          if (res.data.data.photo) {
            setPhotoPreviewUrl(
              `${process.env.REACT_APP_BACKEND_BASE_URL}/uploads/blog/${res.data.data.photo}`
            );
          }
        }
      } catch (error) {
        console.error(error);
        setLoader(true);
      }
    };
    
    getBlogData();
  }, [id]);

  // ================= HANDLE INPUT =================
  const handleInputChange = (e) => {
    const { name, value } = e.target;
    setBlog({ ...blog, [name]: value });
  };

  // ================= HANDLE FILE (10MB VALIDATION) =================
  const handleFileChange = (e) => {
    const file = e.target.files[0];
    if (!file) return;

    const allowedTypes = ["image/jpeg", "image/png", "image/jpg", "image/webp"];
    const maxSize = 10 * 1024 * 1024; // ✅ 10 MB

    if (!allowedTypes.includes(file.type)) {
      Swal.fire({
        icon: "error",
        title: "Invalid File",
        text: "Only JPG, JPEG, PNG, WEBP images are allowed",
      });
      e.target.value = "";
      return;
    }

    if (file.size > maxSize) {
      Swal.fire({
        icon: "error",
        title: "File Too Large",
        text: "Image size must be less than 10 MB",
      });
      e.target.value = "";
      return;
    }

    setBlog({ ...blog, photo: file });
    setPhotoPreviewUrl(URL.createObjectURL(file));
  };

  // ================= SUBMIT =================
  const handleSubmit = async (e) => {
    e.preventDefault();

    if (!blog.title.trim() || !blog.description.trim()) {
      Swal.fire("Please fill all fields", "", "warning");
      return;
    }

    try {
      const formData = new FormData();
      formData.append("title", blog.title);
      formData.append("description", blog.description);

      if (blog.photo) {
        formData.append("photo", blog.photo);
      }

      const res = await axios.put(
        `${process.env.REACT_APP_BACKEND_BASE_URL}/blog/update/${id}`,
        formData
      );

      if (res.status === 200) {
        Swal.fire({
          icon: "success",
          title: "Knowledge Center Updated Successfully",
          timer: 1500,
          showConfirmButton: false,
        }).then(() => navigate("/knowledge-center-list"));
      }
    } catch (error) {
      console.error(error);
      Swal.fire("Something went wrong", "", "error");
    }
  };

  // ================= UI =================
  return (
    <>
      <Adminnavbar />

      {loader || (
        <div className="page-wrapper">
          <div className="content">
            <form onSubmit={handleSubmit}>
              <nav
                aria-label="breadcrumb"
                style={{ "--bs-breadcrumb-divider": "none" }}
              >
                <ol className="breadcrumb">
                  <li className="breadcrumb-item">
                    <Link to="/admindashbord">Dashboard</Link> /
                  </li>
                  <li className="breadcrumb-item">
                    <Link to="/knowledge-center-list">Knowledge Center</Link> /
                  </li>
                  <li className="breadcrumb-item active">Edit Knowledge Center</li>
                </ol>
              </nav>

              <div className="content-page-header">
                <h5>Edit Knowledge Center</h5>
              </div>

              <div className="row">
                {/* TITLE */}
                <div className="col-lg-4">
                  <div className="form-group">
                    <label>Title</label>
                    <input
                      type="text"
                      name="title"
                      className="form-control"
                      value={blog.title}
                      onChange={handleInputChange}
                      required
                    />
                  </div>
                </div>

                {/* DESCRIPTION */}
                <div className="col-lg-6">
                  <div className="form-group">
                    <label>Description</label>
                    <textarea
                      name="description"
                      className="form-control"
                      rows="4"
                      value={blog.description}
                      onChange={handleInputChange}
                      required
                    />
                  </div>
                </div>

                {/* IMAGE */}
                <div className="col-lg-4 mt-3">
                  <div className="form-group">
                    <label>Upload Image (Max 10MB)</label>
                    <input
                      type="file"
                      accept="image/*"
                      className="form-control"
                      onChange={handleFileChange}
                    />
                  </div>
                </div>

                {/* PREVIEW */}
                {photoPreviewUrl && (
                  <div className="col-lg-12 mt-3">
                    <img
                      src={photoPreviewUrl}
                      alt="Preview"
                      style={{
                        width: "300px",
                        height: "200px",
                        objectFit: "cover",
                        borderRadius: "8px",
                        border: "1px solid #ddd",
                      }}
                    />
                  </div>
                )}

                {/* BUTTONS */}
                <div className="col-lg-12 mt-4">
                  <div className="btn-path">
                    <Link to="/knowledge-center-list" className="btn btn-cancel me-3">
                      Back
                    </Link>
                    <button type="submit" className="btn btn-submit">
                      Submit
                    </button>
                  </div>
                </div>
              </div>
            </form>
          </div>
        </div>
      )}
    </>
  );
}
